import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useContext } from '@nuxtjs/composition-api'
import xIcon from '@/assets/img/XIcon.svg'
import playIcon from '@/assets/img/PlayIcon.svg'
import informationCircleIcon from '@/assets/img/InformationCircleIcon.svg'
import questionMarkCircleSolidIcon from '@/assets/img/QuestionMarkCircleSolidIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationFooterOnboardingHelpWindow',
  emits: ["feedback"],
  setup(__props, { emit }: { emit: ({
  (e: 'feedback'): void
}), expose: any, slots: any, attrs: any }) {

const { $config, $user, $notif } = useContext()



const showOnboardingVideo = ref(false)

function closeOnboardingHelpWindow() {
  $notif.onboardingHelpWindowIsShowing = false
}

function openFeedbackForm() {
  $notif.onboardingHelpWindowIsShowing = false
  emit('feedback')
}

function openOnboardingVideo() {
  showOnboardingVideo.value = true
}

function openFaqPage() {
  window.open(
    $user.isCompany
      ? 'https://view.monday.com/1250781027-0f6400a0984b70b25997e6164315abc0?r=euc1'
      : 'https://view.monday.com/1250780860-06ec4dc2562d4728d7109d5093af930c?r=euc1'
  )
}

return { __sfc: true,$config, $user, $notif, emit, showOnboardingVideo, closeOnboardingHelpWindow, openFeedbackForm, openOnboardingVideo, openFaqPage, xIcon, playIcon, informationCircleIcon, questionMarkCircleSolidIcon }
}

})